import ContentCard from "components/ListItemsAndCards/ContentCard/ContentCard.vue"
import NavigationCard from "components/ListItemsAndCards/NavigationCard/NavigationCard.vue"


export default {
    name: "CardList",
    components: {
        ContentCard,
        NavigationCard
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        leader: { 
            type: String,
            required: false,
        },
        cardsResult: {
            type: Array,
            required: true,
        },
        typeCard: {
            type: String,
            required: true,
        },
        colortheme: {
            type: String,
            required: true,
        }

    },
    setup(){
       

        return {
          
        }
    }
}